import { IParsedServiceTerm, IServiceTerm } from '@lib/core/serviceTerms/types';

export const findServiceTermsById = (items: IParsedServiceTerm[] = [], identifier: string = '') => {
  return items.find(item => item.term === identifier || item.identifier === identifier);
};

export const findServiceTermsByCategory = (items: IServiceTerm[] = [], category: string = '') => {
  return items.find(item => item.category === category);
};
